"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";
import { cn } from "./cn";
import { switchRecipe } from "./recipes";

/*
 * The console's on/off control: Base UI's Switch dressed by @nt/ui's recipe.
 * A native checkbox sits off the design system (owner, 2026-10-07); a two-state
 * setting that applies on Save is a switch.
 */
function Switch({
  className,
  size = "default",
  ...props
}: SwitchPrimitive.Root.Props & { size?: "sm" | "default" }) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(switchRecipe.root, className)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={switchRecipe.thumb}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
